import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import useMyHubMenu from '@/Hooks/useMyHubMenu';

const MyHubLanding: React.FC = () => {
  const { menuList } = useMyHubMenu();
  const history = useHistory();

  useEffect(() => {
    // Redirect to the first visible menu item if the current one is not visible
    const firstVisibleMenuItem = menuList.find(menu => menu.isVisible);
    if (firstVisibleMenuItem) {
      history.replace(firstVisibleMenuItem.link);
    }
  }, [history, menuList]);
  return <></>;
};

export default MyHubLanding;
